import React from 'react';
import ReactDOM from 'react-dom/client';
// Inter is self-hosted rather than fetched from fonts.googleapis.com, so no
// request carrying the visitor's IP reaches a third party before consent.
// Weights match tailwind.config.js (fontFamily.sans: Inter).
import '@fontsource/inter/400.css';
import '@fontsource/inter/500.css';
import '@fontsource/inter/600.css';
import '@fontsource/inter/700.css';
import './index.css';
import App from './App';

const root = ReactDOM.createRoot(document.getElementById('root')!);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

